import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { isObject } from 'util';

import { TranslateService } from '../../../../shared/i18n/services/translate.service';
import { State } from '../../../../shared/state-management/reducers';
import { Go } from '../../../../shared/state-management/actions/router';
import { BrowserNotificationService } from '../../../../shared/services/browser-notification/browser-notification.service';
import { SearchMask } from '../models/searchmask.model';
import { searchType as getSearchType } from '../../state-management/reducers';
import { SwitchSearchType } from '../../state-management/actions/settings';
import { UpdateSearchformPa } from '../../state-management/actions/searchform-pa';
import { SubmitQuery } from '../../state-management/actions/query';
import { createQueryFromSearchformNfModel, createQueryFromSearchformNhModel, createQueryFromSearchformPaModel } from '../models/query/query.model';
import { UpdateSearchformNh } from '../../state-management/actions/searchform-nh';
import { UpdateSearchformNf } from '../../state-management/actions/searchform-nf';


@Injectable()
export class PaxloungeService {
	private _isPaxloungeTransferInProgress: boolean = false;

	public get isPaxloungTransferInProgress(): boolean {
		return this._isPaxloungeTransferInProgress;
	}

	public constructor(
		private _translateService: TranslateService,
		private _store: Store<State>,
		private _browserNotifications: BrowserNotificationService,
	) {}

	public fillSearchMaskFromPaxLounge(maskId: number, searchMasks: Array<SearchMask>): void {
		const searchMask: SearchMask = searchMasks.find(mask => mask.id === maskId);

		if (!searchMask) {
			return;
		}

		this._isPaxloungeTransferInProgress = true;

		this._store.dispatch(new Go({path: ['/xena']}));

		this._store.select(getSearchType).take(1).subscribe(currentSearchType => {
			if (currentSearchType !== searchMask.searchType) {
				this._store.dispatch(new SwitchSearchType(searchMask.searchType));
			}

			switch (searchMask.searchType) {
				case 'PA':
					this._store.dispatch(new UpdateSearchformPa(searchMask.form.PA));
					setTimeout(() => this._store.dispatch(new SubmitQuery(createQueryFromSearchformPaModel(searchMask.form.PA))), 1000);
					break;

				case 'NH':
					this._store.dispatch(new UpdateSearchformNh(searchMask.form.NH));
					setTimeout(() => this._store.dispatch(new SubmitQuery(createQueryFromSearchformNhModel(searchMask.form.NH))), 1000);
					break;

				case 'NF':
					this._store.dispatch(new UpdateSearchformNf(searchMask.form.NF));
					setTimeout(() => this._store.dispatch(new SubmitQuery(createQueryFromSearchformNfModel(searchMask.form.NF))), 1000);
					break;
			}

			this._openPaxloungeNotify();
			this._isPaxloungeTransferInProgress = false;
		});
	}

	private _openPaxloungeNotify(): void {
		Notification.requestPermission().then(permissions => {
			if (permissions === 'granted') {
				const notify: Notification = this._browserNotifications.createNotification(
					'XENA',
					this._translateService.translate('passed-to-xena'),
					'../../../../../../assets/images/xena.png'
				);

				if (isObject(notify)) {
					notify.addEventListener('click', function() {
						window.focus();
						notify.close();
					});
				}
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/xena/core/shared/services/paxlounge.service.ts